import * as React from 'react';
import { ButtonVariant } from '../button/Shared';
import { FileExtension } from '../../amorg-common';
import { Button } from '../button/Button';

type FileUploadButtonProps = {
    id?:string,
    inputName:string,
    text?:string,
    toolTipText?:string,
    tooltipHorizontalAlignment?: 'left' | 'right',
    fileTypes:FileExtension[],
    disabled?:boolean,
    magnum?:boolean,
    variant?:ButtonVariant,
    onClickUpload:(file:File)=>Promise<void>
}

export function FileUploadButton(props:FileUploadButtonProps):JSX.Element
{
    const id = props.id || 'file-uploader';

    const fileInputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() =>
    {
        if(props.disabled && fileInputRef.current){
            fileInputRef.current.disabled = true;
        }
    });
    
    async function handleUpload(e:React.ChangeEvent<HTMLInputElement>)
    {
        if(e.target.files?.length > 0){
            await props.onClickUpload(e.target.files[0]);
            if(fileInputRef.current){
                fileInputRef.current.value = '';
            }  
        }
    }

    return (
        <div style={{display:'inline-block'}}>
            <Button 
                variant={props.variant || 'outlined'} 
                size={props.magnum ? 'magnum' : undefined} 
                text={props.text}
                toolTipText={props.toolTipText}
                icon={'cloud_upload'} 
                disabled={props.disabled} 
                onClick={()=>fileInputRef.current.click()}  />
            <input 
                style={{display:'none'}}
                id={id}
                ref={fileInputRef}
                type="file"
                onChange={handleUpload}
                name={props.inputName} // Must match name used by multer
                accept={props.fileTypes.map(ft => '.'+ft).join(',')}
                disabled={props.disabled}
            />
        </div>
    );
}